import React from "react";
import { useMyContext } from "../../../../../screens/GSTModule/GstrForms/GstrThreeB/ContextApi";
import { TableHeadersType } from "../../../../../constant/tableHeadersConstants/tableHeadersType";
type AppProps = {
  data: any;
  tableHeaderData: TableHeadersType[];
};
const Gstr3BFivePointOneTableData = ({ data, tableHeaderData }: AppProps) => {
  const handleGstrThreeBInvoiceListData = useMyContext();

  return (
    <>
      {data?.map((item: any) => {
        return (
          <tr key={item?.natureOfSupplies}>
            {tableHeaderData?.map((header: any) => {
              if (header.value === "description") {
                return (
                  <td>
                    <span>{item?.natureOfSupplies}</span>
                    {item?.isSource ? (
                      <span
                        style={{
                          color: "red",
                          marginLeft: "12px",
                          marginTop: "1px",
                          fontSize: "12px",
                          cursor: "pointer",
                        }}
                        onClick={() => handleGstrThreeBInvoiceListData("5_1")}
                      >
                        View Source
                      </span>
                    ) : null}
                  </td>
                );
              } else if (header.value === "total_count") {
                return (
                  <td>
                    {item?.tableRowData?.total_count
                      ? item?.tableRowData?.total_count
                      : 0}
                  </td>
                );
              } else if (header.value === "total_taxable_value") {
                return (
                  <td>
                    {item?.tableRowData?.total_taxable_value
                      ? item?.tableRowData?.total_taxable_value?.toFixed(2)
                      : "NA"}
                  </td>
                );
              } else if (header.value === "total_igst_amount") {
                return (
                  <td>
                    {item?.tableRowData?.total_igst_amount
                      ? item?.tableRowData?.total_igst_amount?.toFixed(2)
                      : "NA"}
                  </td>
                );
              } else {
                return <td>0</td>;
              }
            })}
          </tr>
        );
      })}
    </>
  );
};

export default Gstr3BFivePointOneTableData;
